document.documentElement.classList.add('js');

document.querySelectorAll('.category-tabs a').forEach((tab) => {
  tab.addEventListener('click', () => {
    tab.closest('.category-tabs')?.querySelectorAll('a').forEach((item) => item.classList.remove('is-active'));
    tab.classList.add('is-active');
  });
});

document.querySelectorAll('[data-scroll-target="collections"]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const target = document.getElementById('collections');
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', '#collections');
  });
});

document.querySelectorAll('[data-collections-section]').forEach((section) => {
  const cards = Array.from(section.querySelectorAll('[data-product-card]'));
  const empty = section.querySelector('[data-filter-empty]');

  section.querySelectorAll('[data-collection-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.collectionFilter;
      let visibleCount = 0;

      button.closest('.category-tabs')?.querySelectorAll('[data-collection-filter]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
      });

      cards.forEach((card) => {
        const visible = filter === 'all' || (card.dataset.filterGroup || '').split(' ').includes(filter);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount > 0;
    });
  });
});

const predictiveSearch = document.querySelector('[data-predictive-search]');

if (predictiveSearch) {
  const toggle = document.querySelector('[data-search-toggle]');
  const close = predictiveSearch.querySelector('[data-search-close]');
  const input = predictiveSearch.querySelector('[data-predictive-input]');
  const results = predictiveSearch.querySelector('[data-predictive-results]');
  let searchTimer;
  let activeController;

  const openSearch = () => {
    predictiveSearch.hidden = false;
    toggle?.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => input?.focus(), 0);
  };

  const closeSearch = () => {
    predictiveSearch.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
    if (input) input.value = '';
    if (results) results.innerHTML = '';
  };

  const productPrice = (product) => {
    if (typeof product.price === 'string') return product.price;
    if (typeof product.price === 'number') return product.price.toLocaleString('fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    });
    return '';
  };

  const renderPredictiveProducts = (products) => {
    if (!results) return;

    if (!products.length) {
      results.innerHTML = '<p class="predictive-search__empty">Aucun produit trouvé ♡</p>';
      return;
    }

    results.innerHTML = products.map((product) => {
      const image = typeof product.image === 'string' ? product.image : product.image?.url || product.featured_image?.url || '';
      const price = productPrice(product);
      return `
        <a class="predictive-search__result" href="${product.url}">
          ${image ? `<img src="${image}" alt="">` : '<span></span>'}
          <strong>${product.title}</strong>
          <span>${price}</span>
        </a>
      `;
    }).join('');
  };

  const searchProducts = async (query) => {
    const term = query.trim();
    if (!term) {
      if (results) results.innerHTML = '';
      return;
    }

    activeController?.abort();
    activeController = new AbortController();

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const response = await fetch(url, {
        headers: { 'Accept': 'application/json' },
        signal: activeController.signal
      });

      if (!response.ok) throw new Error('Predictive search failed');

      const data = await response.json();
      renderPredictiveProducts(data.resources?.results?.products || []);
    } catch (error) {
      if (error.name !== 'AbortError') renderPredictiveProducts([]);
    }
  };

  toggle?.addEventListener('click', openSearch);
  close?.addEventListener('click', closeSearch);
  input?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(() => searchProducts(input.value), 180);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !predictiveSearch.hidden) closeSearch();
  });
}

const cartSection = document.querySelector('[data-cart-section]');

if (cartSection) {
  const moneyFormat = cartSection.dataset.moneyFormat || '{{ amount }} €';
  const quantityTimers = new Map();

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const value = Number(cents || 0) / 100;
    const formatted = value
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));
  };

  const updateCartBadge = (itemCount) => {
    document.querySelectorAll('.cart-link span').forEach((badge) => {
      badge.textContent = itemCount;
    });
  };

  const renderCartState = (cart) => {
    cart.items.forEach((item) => {
      const line = cartSection.querySelector(`[data-cart-line][data-line-key="${CSS.escape(item.key)}"]`);
      if (!line) return;

      const price = line.querySelector('[data-line-price]');
      const input = line.querySelector('[data-cart-quantity]');

      if (price) price.textContent = formatMoney(item.final_line_price);
      if (input && Number(input.value) !== item.quantity) input.value = item.quantity;
    });

    cartSection.querySelectorAll('[data-cart-line]').forEach((line) => {
      const key = line.dataset.lineKey;
      if (!cart.items.some((item) => item.key === key)) line.remove();
    });

    const subtotal = cartSection.querySelector('[data-cart-subtotal]');
    const productsSubtotal = typeof cart.items_subtotal_price === 'number'
      ? cart.items_subtotal_price
      : cart.items.reduce((total, item) => total + Number(item.final_line_price || 0), 0);
    if (subtotal) subtotal.textContent = formatMoney(productsSubtotal);

    updateCartBadge(cart.item_count);

    const form = cartSection.querySelector('[data-cart-form]');
    if (cart.item_count === 0 && form) {
      form.replaceWith(Object.assign(document.createElement('p'), {
        textContent: 'Votre panier est vide.'
      }));
    }
  };

  const changeCartQuantity = async (input) => {
    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
    const previousValue = input.defaultValue;
    input.disabled = true;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: input.dataset.lineKey,
          quantity
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      const cart = await response.json();
      input.defaultValue = String(quantity);
      renderCartState(cart);
    } catch (error) {
      input.value = previousValue;
      console.error(error);
    } finally {
      input.disabled = false;
    }
  };

  cartSection.addEventListener('input', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;

    window.clearTimeout(quantityTimers.get(input));
    quantityTimers.set(input, window.setTimeout(() => changeCartQuantity(input), 250));
  });

  cartSection.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;

    window.clearTimeout(quantityTimers.get(input));
    changeCartQuantity(input);
  });
}
